import React from 'react'

interface PriceContainerProps {
  price: number;
  color: string;
}

const PriceContainer: React.FC<PriceContainerProps> = ({ price, color }) => {
  return (
    <div className="price-container">
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 165.474 161.415"
        xmlns="http://www.w3.org/2000/svg"
        style={{ color }}
      >
        <path
          id="Polygon_1"
          data-name="Polygon 1"
          d="M84.313,5.571A14.047,14.047,0,0,1,102.1,9.63l.067.09a14.047,14.047,0,0,0,11.765,5.655l.126,0A14.047,14.047,0,0,1,128.351,26.76l.009.046a14.047,14.047,0,0,0,8.165,10.22l.059.026a14.047,14.047,0,0,1,7.943,16.487h0a14.047,14.047,0,0,0,2.921,12.774l.005.006a14.047,14.047,0,0,1,0,18.313l-.005.006a14.047,14.047,0,0,0-2.921,12.774h0a14.047,14.047,0,0,1-7.943,16.487l-.059.026a14.047,14.047,0,0,0-8.165,10.22l-.009.046a14.047,14.047,0,0,1-14.288,11.389l-.126,0a14.047,14.047,0,0,0-11.765,5.655l-.067.09a14.047,14.047,0,0,1-17.792,4.059l-.131-.068a14.047,14.047,0,0,0-13.041,0l-.131.068a14.047,14.047,0,0,1-17.792-4.059l-.067-.09a14.047,14.047,0,0,0-11.765-5.655l-.126,0a14.047,14.047,0,0,1-14.288-11.389l-.009-.046a14.047,14.047,0,0,0-8.165-10.22l-.059-.026A14.047,14.047,0,0,1,10.8,97.41h0A14.047,14.047,0,0,0,7.875,84.636L7.87,84.63a14.047,14.047,0,0,1,0-18.313l.005-.006A14.047,14.047,0,0,0,10.8,53.538h0A14.047,14.047,0,0,1,18.74,37.051l.059-.026a14.047,14.047,0,0,0,8.165-10.22l.009-.046A14.047,14.047,0,0,1,41.26,15.371l.126,0A14.047,14.047,0,0,0,53.151,9.72l.067-.09A14.047,14.047,0,0,1,71.01,5.571l.131.068a14.047,14.047,0,0,0,13.041,0Z"
          transform="matrix(0.998, -0.07, 0.07, 0.998, 0, 10.835)"
          fill="currentColor"
        />
      </svg>
      <div className="price">{price} kr</div>
    </div>
  )
}

export default PriceContainer
